export const eligibleCountries = ['US', 'CA'];
